import NavBar from "./components/NavBar/NavBar";
import Main from "./components/Main/Main";
import AboutMe from "./components/AboutMe/AboutMe";
import Skills from "./components/Skills/Skills";
import Projects from "./components/Projects/Projects";
import Experience from "./components/Experience/Experience";
import Contact from "./components/Contact/Contact";
import Loader from "./components/Loader/Loader";
import { useState, useEffect } from "react";

function App() {
  const [IsLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simula un tiempo de carga
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 2 segundos de carga

    return () => clearTimeout(timer);
  }, []);

  if (IsLoading) {
    return <Loader />;
  }

  return (
    <>
      <NavBar/>
      <section id="main"><Main /></section>
      <section id="projects"><Projects /></section>
      <section id="about-me"><AboutMe /></section>
      <section id="skills"><Skills /></section>
      <section id="experience"><Experience /></section>
      <section id="contact"><Contact /></section>
    </>    
  );
}

export default App;
